import { Component, Input, OnInit } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { DataCardService } from '../../../../../services/data-card.service'
import { IDataCardNotification, IDataCardWorkOrder } from '../../../../../models/data-card.model'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'

@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrl: './notification-modal.component.scss',
    standalone: false
})
export class NotificationModalComponent implements OnInit {
  @Input() items: { name: string; title: string; url: string; status?: number }[] = []
  @Input() type: 'WO' | 'NO' = 'NO'
  @Input() item: { name: string; title: string; url: string; status?: number }

  private _noData: IDataCardNotification
  private _woData: IDataCardWorkOrder
  private _isLoading: boolean = false

  public get noData(): IDataCardNotification {
    return this._noData
  }

  public get woData(): IDataCardWorkOrder {
    return this._woData
  }

  public get isLoading(): any {
    return this._isLoading
  }

  constructor(
    private activeModal: NgbActiveModal,
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public cancel(): void {
    this.activeModal.dismiss({})
  }

  public getTitle(): string {
    if (this.type === 'WO') {
      return 'WO @ Incident'
    }
    return 'Notifications'
  }

  private getWorkOrderData(): void {
    this._isLoading = true
    this.dataCardService.getWorkOrderData(this.item.name).subscribe({
      next: (resource: IDataCardWorkOrder): void => {
        this._woData = resource
        if (this.items.length === 1 && this.itemHasPartialData(this.items[0])) {
          this.items[0].title = this._woData.title
          this.items[0].url = this._woData.url
        }
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  private getNotificationData(): void {
    this._isLoading = true
    this.dataCardService.getNotificationData(this.item.name).subscribe({
      next: (resource: IDataCardNotification): void => {
        this._noData = resource
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  private itemHasPartialData(item: {
    name: string
    title: string
    url: string
    status?: number
  }): boolean {
    return item.title.length === 0 || item.url.length === 0
  }

  public ngOnInit(): void {
    if (this.item) {
      if (this.type === 'WO') {
        this.getWorkOrderData()
      } else if (this.type === 'NO') {
        this.getNotificationData()
      }
    }
  }
}
